import React, { Component } from 'react';

class Footer extends Component {
  render() {
    if (this.props.footer) {
      var { myright } = this.props.footer
    }
    if (this.props.data) {
      var networks = this.props.data.social.map(function (network) {
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }
    var year = new Date().getFullYear()

    return (
      <footer>
        <div className="row">
          <div className="twelve columns">
            <ul className="social-links">
              {networks}
            </ul>
            <ul className="copyright">
              <li>&copy; {year} <span id="nickname">Moises Borracha</span> | {myright} <span id="nickname">BlackBeard</span> <i className="fas fa-heart" id="myheart"></i> </li>
            </ul>
          </div>
          <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
        </div>
      </footer>
    );
  }
}

export default Footer;
